module.exports = __webpack_public_path__ + "static/media/b11.fa843e48.jpg";